import { render, staticRenderFns } from "./myGrade.vue?vue&type=template&id=5e67d00f&"
import script from "./myGrade.vue?vue&type=script&lang=js&"
export * from "./myGrade.vue?vue&type=script&lang=js&"
import style0 from "./myGrade.vue?vue&type=style&index=0&id=5e67d00f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports